import { API_URL, defaultFetchOptions } from '../config/api';
import { supabase } from './supabase';

export class ApiError extends Error {
  constructor(message, { status = null, code = null, details = null } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

async function getAuthHeaders() {
  try {
    const { data } = await supabase.auth.getSession();
    const accessToken = data?.session?.access_token;
    if (!accessToken) {
      return {};
    }
    return {
      Authorization: `Bearer ${accessToken}`,
    };
  } catch (error) {
    return {};
  }
}

export async function buildRequestHeaders(extraHeaders = {}, options = {}) {
  const authHeaders = await getAuthHeaders();
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const baseHeaders = isFormData ? {} : (defaultFetchOptions.headers || {});

  return {
    ...baseHeaders,
    ...authHeaders,
    ...extraHeaders,
  };
}

export async function apiRequest(endpoint, options = {}) {
  const headers = await buildRequestHeaders(options.headers || {}, options);

  return fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });
}

async function parseErrorResponse(response) {
  let payload = null;
  let responseText = '';

  try {
    responseText = await response.text();
  } catch {
    responseText = '';
  }

  if (responseText) {
    try {
      payload = JSON.parse(responseText);
    } catch {
      payload = null;
    }
  }

  const apiError = payload?.error;
  const message = apiError?.message || responseText || `Request failed with status ${response.status}`;
  const code = apiError?.code || `http_${response.status}`;
  const details = apiError?.details || null;

  return new ApiError(message, {
    status: response.status,
    code,
    details,
  });
}

export async function assertOk(response) {
  if (response.ok) {
    return response;
  }

  throw await parseErrorResponse(response);
}

export async function apiJson(endpoint, options = {}) {
  const response = await apiRequest(endpoint, options);
  await assertOk(response);
  return response.json();
}

export async function apiText(endpoint, options = {}) {
  const response = await apiRequest(endpoint, options);
  await assertOk(response);
  return response.text();
}
